import './global';

// Marketing Scripts
import { initializeSdk } from './utils/sdk';
import { removeOneTrustLink } from './utils/helpers';
import { preFetch, convertNodes, setupRichTextForTracking } from './Global/utils/helpers';
import { onScrollInit, lazyLoadInit } from './components/onScroll';
import { onHeroInit } from './components/hero';
import { onGridsInit } from './components/grid';
import { langSelectorInit } from './components/langSelector';
import { carouselInit } from './components/carousel';
import { initButtonActions } from 'v2-scripts/utils/buttonActions';
import { initModal } from './components/modal';
import { isDeviceSupported } from './device/checkDevice';
import {
    activateAllCategories,
    addOneTrustOnConsentFunction,
    initalizeOneTrust,
    loadAdobeSuites,
    setFallbackActiveGroup,
    syncOneTrustConsent
} from 'oneTrust/oneTrust';

// Analytics
import AnalyticsManager from './analytics/analyticsManager';
import { initAdobeAnalytics } from './analytics/adobeAnalytics';
import { initAdobeLaunch } from './analytics/adobeLaunch';
import glimpseV2Tracking from './analytics/glimpseV2Tracking';


// 3rd Party Plugins
import { deepGet } from 'bam-deep-get';
import LazyLoad from 'vanilla-lazyload';
import './utils/polyfills';

// Internet Explorer Polyfills
import intersectionObserver from 'intersection-observer'; // eslint-disable-line no-unused-vars


/**
 * @description The application entry point
 */
export function init() {

    if (!isDeviceSupported()) {
        window.location = '/unsupported';
    }

    lazyLoadInit(LazyLoad);
    convertNodes();
    onScrollInit();
    onHeroInit();
    onGridsInit();
    carouselInit();
    initModal();
    langSelectorInit();
    initButtonActions();
    setupRichTextForTracking();

    try {
        localStorage.removeItem('dss_super_bundle_selected');
    } catch (e) {}

    initializeSdk(sdkPayload => {
        if (sdkPayload) {
            window.AnalyticsManager = window.AnalyticsManager || new AnalyticsManager(sdkPayload);
            initAdobeAnalytics();
            glimpseV2Tracking.initGlimpseV2();
            window.AnalyticsManager.firePageLoad();

            if (window.OneTrust) {

                addOneTrustOnConsentFunction(loadAdobeSuites);

                const oneTrustTrack = () => {
                    window.AnalyticsManager.fireAction('Content Update Success');
                    window.AnalyticsManager.fireGlimpseEvent('consentGranted');

                    const id = deepGet(sdkPayload, 'sessionInfo.account.id', null);
                    const countryCode = deepGet(sdkPayload, 'sessionInfo.location.countryCode', '');

                    syncOneTrustConsent(id || window.AnalyticsManager.userData.dssDeviceId, !!(id), countryCode);
                };

                initalizeOneTrust(oneTrustTrack, {
                    onload: () => {
                        const prefLink = document.querySelector('.onetrust-manage');
                        if (prefLink) {
                            prefLink.style.display = 'inline-block';
                        }
                    },
                    onerror: () => {
                        setFallbackActiveGroup();
                        removeOneTrustLink();
                    }
                });
            } else {
                activateAllCategories();
                loadAdobeSuites(true);
                removeOneTrustLink();
            }
        }

        glimpseV2Tracking.trackDefinedEvent('appEvents', 'lifecycle', 'loadEnd');
        // Prefetch sign-up and login
        preFetch();
    });
}


/**
 * @description Run init function on dom ready and when critical scripts done
 */

// If there is a WeaponX experiment on the page, do not execute init yet.
if (window.abTest) {
    // Wait for WeaponX Script to be finished before continuing
    window.weaponxScript.then(() => { init(); });
} else {
    init();
}

